module.exports = __webpack_public_path__ + "static/img/icon15.175299e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon15.png
// module id = FzTO
// module chunks = 1